import { callTool } from "../api";
import type { BoothCheckIn } from "../types";

export type TeamTimelineKind = "checkin" | "contact" | "note";

export type TeamTimelineItem = {
  kind: TeamTimelineKind;
  id: string;
  at: string;
  title: string;
  subtitle?: string | null;
  account_id?: string | null;
  booth?: string | null;
};

export type TeamActivityAccount = {
  account_id: string;
  name: string | null;
  booth: string | null;
  hall: string | null;
  ai_rating: number | null;
  my_favorite: boolean;
  my_owner: boolean;
  closed_out: boolean;
};

export type TeamActivityPayload = {
  timeline: TeamTimelineItem[];
  accounts: TeamActivityAccount[];
};

type ToolResult = {
  timeline?: TeamTimelineItem[];
  accounts?: TeamActivityAccount[];
};

export async function loadTeamActivity(opts: {
  eventKey: string;
  campaignKey: string;
  userKey: string;
  checkIns?: BoothCheckIn[];
}): Promise<TeamActivityPayload> {
  const data = await callTool<ToolResult>("team_member_activity", {
    event_key: opts.eventKey,
    campaign_key: opts.campaignKey,
    user_key: opts.userKey,
    limit: 80,
  });
  const intelTimeline = Array.isArray(data.timeline) ? data.timeline : [];
  const checkInTimeline: TeamTimelineItem[] = (opts.checkIns ?? []).map((entry) => ({
    kind: "checkin",
    id: `checkin:${entry.booth_id}:${entry.at}`,
    at: entry.at,
    title: entry.booth_label ? `${entry.booth_label} ${entry.booth_id}` : `Booth ${entry.booth_id}`,
    subtitle: "Check-in",
    booth: entry.booth_id,
  }));
  const timeline = [...intelTimeline, ...checkInTimeline].sort((a, b) => b.at.localeCompare(a.at) || a.id.localeCompare(b.id));
  return {
    timeline,
    accounts: Array.isArray(data.accounts) ? data.accounts : [],
  };
}
